import { useMutation } from "@tanstack/react-query";
import { AuthRepository } from "./repositories/auth-repository";
import { ApiPhoneCheckRequest, ApiPhoneRequest } from "./types/auth/api-types";
import { useMessage } from "@/app/messageContext";
import { queryClient } from "./http-client/base-client";

export const useAuthPhone = (onSuccess: () => void) => {
  const messageApi = useMessage();
  return useMutation({
    mutationFn: AuthRepository.sendPhone,
    onSuccess,
    onError: (error) => {
      messageApi.error(error.message);
    },
  });
};

export const useAuthPhoneCheck = (
  onSuccess: () => void,
  onError: () => void,
) => {
  const messageApi = useMessage();
  return useMutation({
    mutationFn: AuthRepository.verifyPhone,
    onSuccess: () => {
      onSuccess();
      queryClient.invalidateQueries({ queryKey: ["user"] });
      messageApi.success("Телефон успешно подтверждён");
    },
    onError: (error) => {
      onError();
      messageApi.error(error.message);
    },
  });
};
